export default "__VITE_PUBLIC_ASSET__8c676470__"